"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _dateFormatting = _interopRequireDefault(require("@insided/shared/utils/dateFormatting"));

var Report = function Report(_ref) {
  var reason = _ref.reason,
      reportedAt = _ref.reportedAt,
      reportedBy = _ref.reportedBy;
  var formattedReportedAt = (0, _dateFormatting.default)(new Date(reportedAt).getTime() / 1000);
  return (0, _preact.h)("div", {
    className: "message-in-content message-in-content--reported"
  }, (0, _preact.h)("div", {
    className: "report-metadata"
  }, (0, _preact.h)("strong", null, reportedBy.username), (0, _preact.h)("span", {
    className: "report-metadata__reported-at"
  }, "on ", formattedReportedAt)), (0, _preact.h)("div", null, reason));
};

var _default = Report;
exports.default = _default;